export const phoneRegexp =
  /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{4,6}$/;

export default function checkPhoneNumber(phoneNumber: string) {
  const cleanedPhone = phoneNumber.replace(/[\s()-]/g, '');

  return phoneRegexp.test(cleanedPhone);
}
